import * as v2 from '@/core/services/api/v2';

/**
 * As árvores de habilidades (1.3).
 *
 * A store guarda **a visão inteira** que o servidor devolve — pontos, as três
 * árvores com cada habilidade (nível, se libera, por que não, o efeito já
 * escrito) e o reset — e substitui tudo a cada resposta. Nada é derivado
 * aqui: quem decide se um ponto entra é o domínio do servidor, e o efeito
 * chega formatado ("+10 %", "ativo") porque o cliente não espelha fórmula.
 * É a mesma regra da roda de melhorias, que já divergiu uma vez.
 */

const state = {
  visao: null,
  loading: false,
  error: null,
};

const mutations = {
  SET_VISAO(state, visao) {
    state.visao = visao;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

/** O V2 responde `{ message, codigo }`; o código é o que o i18n traduz. */
const codigoDe = (error) =>
  error?.response?.data?.codigo || error?.response?.data?.message || error?.message || 'erro';

const actions = {
  async carregar({ commit, rootState }) {
    const playerId = rootState.player?.id;
    if (!playerId) return;
    commit('SET_LOADING', true);
    try {
      commit('SET_VISAO', await v2.habilidades(playerId));
      commit('SET_ERROR', null);
    } catch (error) {
      commit('SET_ERROR', codigoDe(error));
    } finally {
      commit('SET_LOADING', false);
    }
  },

  /** Um ponto. A resposta é a visão nova; o erro vem por código. */
  async alocar({ commit, rootState }, skillId) {
    const playerId = rootState.player?.id;
    if (!playerId) return { ok: false, codigo: 'sem_jogador' };
    commit('SET_LOADING', true);
    try {
      commit('SET_VISAO', await v2.alocarHabilidade(playerId, skillId));
      commit('SET_ERROR', null);
      return { ok: true };
    } catch (error) {
      const codigo = codigoDe(error);
      commit('SET_ERROR', codigo);
      return { ok: false, codigo };
    } finally {
      commit('SET_LOADING', false);
    }
  },

  /** Reset total. Debita ouro: a store do jogador é atualizada com o que o perfil diz. */
  async resetar({ commit, dispatch, rootState }) {
    const playerId = rootState.player?.id;
    if (!playerId) return { ok: false, codigo: 'sem_jogador' };
    commit('SET_LOADING', true);
    try {
      commit('SET_VISAO', await v2.resetarHabilidades(playerId));
      commit('SET_ERROR', null);
      await dispatch('player/updateGold', null, { root: true });
      return { ok: true };
    } catch (error) {
      const codigo = codigoDe(error);
      commit('SET_ERROR', codigo);
      return { ok: false, codigo };
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

const getters = {
  visao: (state) => state.visao,
  pontos: (state) => state.visao?.pontos || { total: 0, alocados: 0, disponiveis: 0 },
  arvore: (state) => (id) => state.visao?.arvores?.find((a) => a.id === id) || null,
  capstone: (state) => state.visao?.capstone || null,
  reset: (state) => state.visao?.reset || { custo: 0, disponivelEm: null },
  isLoading: (state) => state.loading,
  getError: (state) => state.error,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
